import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        lang: 'zh', // 中英文
        pathName: '/', // 路径
        productTitle: '', // 项目名称
        isShowLoading: true, // 页面是否加载中
        menuList: [], // 底部导航条
        toastData: null, // toast数据
        userInfo: '', // 用户信息
        hisLen: 0,
        ActiveName: false, // 登录状态
        materialsStatus: null // 认证审核状态
    },
    mutations: {
        setLang(state, lang) {
            state.lang = lang
        },
        setPathName(state, path) {
            state.pathName = path
        },
        setProductTitle(state, name) {
            state.productTitle = name
        },
        setShowLoading(state, flag) {
            state.isShowLoading = flag
        },
        setMenuList(state, list) {
            state.menuList = list
        },
        setToastData(state, data) {
            state.toastData = data
        },
        setUserInfo(state, data) {
            data ? state.userInfo = data : state.userInfo = ''
        },
        setHisLen(state, num) {
            state.hisLen = num
        },
        setActiveName(state, sta) {
            state.ActiveName = sta
        },
        setMaterialsStatus(state, sta) {
            state.materialsStatus = sta
        }
    },
    actions: {},
    modules: {}
})